import Image from "components/Elements/Image/Image";

import { memo } from "react";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./suspendedUserError.module.scss";

const SuspendedUserError = memo(() => {
  const { getHtmlByKey } = useContent();
  return (
    <div className={styles.wrapper}>
      <Image name="exclamation" ext="png" />
      <p className={styles.description}>{getHtmlByKey("suspended-user-description")}</p>
    </div>
  );
});

export default SuspendedUserError;
